// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"977dddf5","693":"7022f4f9","845":"903ac0ba"}[chunkId] + ".chunk.js";
};